module.exports = __webpack_public_path__ + "static/media/ribbon-icon_2x.95b6f7cf.png";